<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'800px'"
    :classDialog="'createDialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Báo cáo theo dõi chỉ đạo
      </h5>
    </template>

    <template #body>
      <hc-quy-che-quy-dinh-bao-cao-form
        :id="id"
        ref="hcQuyCheQuyDinhBaoCaoFormRef"
      />
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="save"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Lưu
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
          >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import CustomDialog from "../../common/custom-dialog";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import HcQuyCheQuyDinhBaoCaoForm from "./hc-quychequydinh-bao-cao-form";
import hcQuyCheQuyDinhService from "../../../services/quychequydinh/hcQuyCheQuyDinhService";

export default {
  name: "hc-quychequydinh-bao-cao-dialog",
  props: ["isOpen", "id"],
  mixins: [handleRequestErrorMixin],
  components: { HcQuyCheQuyDinhBaoCaoForm, CustomDialog },

  data() {
    return {};
  },

  methods: {
    convertToSubmitForm() {
      return this.$refs.hcQuyCheQuyDinhBaoCaoFormRef.convertToSubmitForm();
    },

    validateForm() {
      return this.$refs.hcQuyCheQuyDinhBaoCaoFormRef.validateForm();
    },

    save() {
      return this.validateForm()
        .then(() => {
          let submitForm = this.convertToSubmitForm();
          return hcQuyCheQuyDinhService
            .baoCaoChiDao(this.id, submitForm)
            .then(response => response.data);
        })
        .then(hcQuyCheQuyDinh => {
          this.$message({
            message: errorMessageFilter({
              errorCode: "hcQuyTrinh.baoCaoSuccess"
            }),
            type: "success"
          });
          this.$emit("success", { result: hcQuyCheQuyDinh });
        })
        .catch(error => {
          this.commonHandleRequestError(error);
          throw error;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/adminstration/quychequydinh/hc-quychequydinh-bao-cao-dialog.vue